import { render } from "./DynamicConsumerLayout.vue?vue&type=template&id=af38b20c"
import script from "./DynamicConsumerLayout.vue?vue&type=script&lang=js"
export * from "./DynamicConsumerLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__